import { render, staticRenderFns } from "./Design1.vue?vue&type=template&id=080f02a2&"
import script from "./Design1.vue?vue&type=script&lang=js&"
export * from "./Design1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports